import { Button, Input, RowItem } from '@/components';
import type { IRowItemProps } from '@/components/layout/bordered-layout/row-item';
import { REGEX } from '@/constant';
import { getFieldInputProps } from '@/utils';
import { memo } from 'react';

import { FormikProps } from 'formik';

import { useLogic } from './logic';

type TDomainVerifyField = {
	formik: FormikProps<{ [key: string]: any }> | any;
	fieldName?: string;
	placeholder?: string;
	disabled?: boolean;
	required?: boolean;
} & IRowItemProps;

const DomainVerifyField = ({
	formik,
	label = '도메인 정보',
	fieldName = 'subDomain',
	placeholder = '영문 소문자,-',
	disabled,
	required = false,
	...rest
}: TDomainVerifyField) => {
	const { verifyDomain, getAdditionalValues, isAvailableDomain } =
		useLogic(formik);

	return (
		<RowItem
			label={label}
			childrenClassName="flex items-center gap-3"
			required={required}
			{...rest}
		>
			<Input
				{...getFieldInputProps(formik, fieldName, {
					regex: REGEX.ONLY_EN_LOWER_CASE_DASH,
					getAdditionalValues,
				})}
				maxLength={60}
				isValidValue={isAvailableDomain}
				placeholder={placeholder}
				disabled={disabled}
				containerClassName="flex-1"
			/>
			<p className="text-font2 text-[13px]">.kollabo.kr</p>
			{!disabled ? (
				<Button
					secondary
					className="!min-w-[88px] font-normal text-base"
					onClick={verifyDomain}
					disabled={!required && !formik.values[fieldName]}
				>
					중복체크
				</Button>
			) : null}
		</RowItem>
	);
};

export default memo(DomainVerifyField);
